import type { ResponsiveAction } from "./types";

export const isIconOnlySize = (action: ResponsiveAction) =>
  action.size === "icon" || action.size === "tinyIcon";

export const partitionActions = (actions: ResponsiveAction[]) => {
  const pinnedActions: ResponsiveAction[] = [];
  const overflowActions: ResponsiveAction[] = [];

  for (const action of actions) {
    if (action.alwaysVisible) {
      pinnedActions.push(action);
    } else {
      overflowActions.push(action);
    }
  }

  return { pinnedActions, overflowActions };
};
